// extracted by mini-css-extract-plugin
module.exports = {"badges":"PreviewBadges_badges__Yg6YC","badge":"PreviewBadges_badge__BqqM_","scheduledBadge":"PreviewBadges_scheduledBadge__TmGaq"};